/**
 * Error handler utility for extracting error messages from API responses
 */

export function extractErrorMessage(error: any): string {
  // Handle Axios errors
  if (error?.response) {
    // Server responded with error status
    const data = error.response.data
    if (typeof data === 'string') {
      return data
    }
    if (data?.detail) {
      return data.detail
    }
    if (data?.message) {
      return data.message
    }
    if (data?.error) {
      return data.error
    }
    return `Server error: ${error.response.status}`
  }
  
  // Handle network errors
  if (error?.request) {
    return 'Network error. Please check your connection.'
  }
  
  // Handle custom error messages
  if (error?.message) {
    return error.message
  }
  
  // Default error message
  return 'An unexpected error occurred. Please try again.'
}

export function getErrorMessage(error: any, fallback: string = 'Something went wrong'): string {
  return extractErrorMessage(error) || fallback
}